<template>
  <vs-popup class="customer-sample-order-create-popup"
            id="popup"
            title="FG STOCK INVENTORY LABEL"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <pdf ref="myPdfComponent" class="object-scale-down" :src="file" ></pdf>
        </vs-col>
      </vs-row>

      <div class="flex flex-wrap items-center justify-end mt-8">
        <vs-button @click="onClickDownload" button="submit" icon-pack="feather" icon="icon-download-cloud" color="primary" class="ml-auto mt-2">Download</vs-button>
        <vs-button @click="onClickprint" button="submit" icon-pack="feather" icon="icon-printer" color="danger" class="ml-2 mt-2">Print</vs-button>
      </div>

      <span style="display: none">{{file}}</span>
    </vx-card>
  </vs-popup>
</template>

<script>
  import pdf from 'vue-pdf'
  import axios from "../../../../axios";
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      file: '',
      label_name: ''
    }
  }

  export default {
    name: 'ProductStockLabelPopUp',
    data () {
      return initialState()
    },
    methods:{
      async onClickDownload() {
        const link = document.createElement('a');
        link.href = this.file;
        link.download = this.label_name
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      async openPopup (id, wo, fg_code) {
        try {
          await Object.assign(this.$data, initialState())
          this.id = id
          this.label_name = `${wo}_${fg_code}_label.pdf`
          await this.getRmOrderItemLabel()


        } catch (error) {

        }
      },
      async getRmOrderItemLabel() {
        this.$vs.loading()
        try {
          axios(`/admin/inventory/stock/product-stock/${this.id}/pdf`, {
            method: 'GET',
            responseType: 'blob'
          })
            .then(response => {
              //Create a Blob from the PDF Stream
              const file = new Blob(
                [response.data],
                {type: 'application/pdf'});
              //Build a URL from the file
              this.file = URL.createObjectURL(file)
              this.open = true;
              this.$vs.loading.close()
              //Open the URL on new Window
            })
        } catch (e) {
          this.$vs.loading.close()
        }
      },
      onClickprint() {
        const win = window.open(this.file);
        win.focus();
        win.print();
      }
    },
    components: {
      'v-select': vSelect,
      pdf
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .customer-sample-order-create-popup >>> .vs-popup {
    /*min-height: 78% !important;*/
    min-width: 20% !important;
  }

</style>
